<div class="quick-bet-each-way-total-stake">
    <div class="caption">{{ totalStakeText }}</div>
    <div class="value">{{ totalStake | bsCurrency: true }}</div>
</div>
